import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import autobind from 'react-autobind'
import { Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Alert from "../components/Errors/Alert"

import * as actions from "../redux/actions"

import logo from "../img/indexAR-logo-white.png";
import sponsor1 from "../img/sponsor1.png";
import sponsor2 from "../img/sponsor2.png";
import sponsor3 from "../img/sponsor3.png";

class LoginPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      isAuthentified: false
    };
    autobind(this)
  }

  onEmailChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  onPasswordChange(event) {
    this.setState({
      password: event.target.value
    });
  }

  onLoginButtonClick(e) {
    e.preventDefault();
    const { email, password } = this.state;
    const { login, checkLogin } = this.props;
    login(email, password).then(() => {
      checkLogin().then(() => {
        this.setState({
          isAuthentified: true
        });
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    const { email, password, isAuthentified } = this.state;
    const { user, error } = this.props

    if (isAuthentified && user) {

      if (user.role === 3) {
        return <Redirect to="/s/dashboard" />
      }

      return <Redirect to="/dashboard" />
    }
    return (
      <div className="white-bg-top-wrapper">
        <div className="splash-wrapper">
          <div className="d-flex justify-content-between flex-wrap mb-5">
            <img src={sponsor1} width="135" height="107" alt="Sponsor" />
            <img src={sponsor2} width="114" height="114" alt="Sponsor" />
            <img src={sponsor3} width="127" height="120" alt="Sponsor" />
          </div>
          <div className="splash-container row">
            <img src={logo} alt="logo" width="117" height="102" className="logo-img mb-4 login-logo" />
            <div className="col-sm-6 user-message">
              <span className="splash-message text-right">
Hello,
                <br />
                {' '}
is good to
                <br />
                {' '}
see you again
              </span>
              <span className="alternative-message alternative-message-register">
You don&apost have an account?
                {' '}
                <Link to="/register">Register here!</Link>
              </span>
            </div>
            <div className="col-sm-6 form-message d-flex justify-content-center">
              <div>
                <span className="splash-description text-center mt-5 mb-5">
                                    Login to your account
                </span>
                {error ? <Alert message={error} /> : null}
                <form>
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-addon"><i className="icon s7-user" /></span>
                      <input
                        type="email"
                        placeholder="Email"
                        autoComplete="off"
                        className="form-control"
                        onChange={this.onEmailChange}
                        value={email}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-addon"><i className="icon s7-lock" /></span>
                      <input
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        onChange={this.onPasswordChange}
                        value={password}
                      />
                    </div>
                  </div>
                  <div className="form-group login-submit">
                    <button data-dismiss="modal" type="submit" className="btn btn-lg btn-primary btn-block" onClick={this.onLoginButtonClick}>
                                            Login
                    </button>
                  </div>
                  <div className="form-group row login-tools">
                    <div className="col-12 pt-2 text-right login-forgot-password"><Link to="/request-forgot-password">Forgot Password?</Link></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="text-center mt-px-100">
            <p className="mb-2 disclaimer-text">
Pentru informaţii detaliate despre celelalte programe cofinanţate de Uniunea Europeană, vă invităm să vizitaţi
              {' '}
              <a href="http://www.fonduri-ue.ro">www.fonduri-ue.ro</a>
            </p>
            <p className="text-xs">Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia oficială a Uniunii Europene sau a Guvernului României</p>
          </div>
        </div>
      </div>
    );
  }

}

LoginPage.propTypes = {
  login: PropTypes.func.isRequired,
  checkLogin: PropTypes.func.isRequired,
  user: PropTypes.object,
  error: PropTypes.string
}

LoginPage.defaultProps = {
  user: null,
  error: ''
}

export default connect(
  (state, ownProps) => {
    const { auth: { user, error, loggingIn } } = state
    return {
      user, error, loggingIn
    }
  },
  actions
)(LoginPage)



// WEBPACK FOOTER //
// ./src/containers/Login.js